import { render, staticRenderFns } from "./m-compartilhar.vue?vue&type=template&id=321706a1&"
import script from "./m-compartilhar.vue?vue&type=script&lang=js&"
export * from "./m-compartilhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports